import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding-left: 15px;
  span {
    position: relative;
    color: ${(props) =>
      props.status === 'reviewed'
        ? props.theme.config.colors.primary_600
        : props.status === 'in_progress'
        ? props.theme.config.colors.orange_600
        : props.theme.config.colors.gray};

    &:before {
      content: '';
      position: absolute;
      top: 4px;
      bottom: 0;
      left: -15px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${(props) =>
        props.status === 'reviewed'
          ? props.theme.config.colors.primary_600
          : props.status === 'in_progress'
          ? props.theme.config.colors.orange_600
          : props.theme.config.colors.gray};
    }
  }
`;
